import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="team-filter"
export default class extends Controller {
  static targets = ["searchInput", "membersList", "memberItem"]

  connect() {
    this.originalItems = this.memberItemTargets.slice()
  }

  filter() {
    const query = this.searchInputTarget.value.toLowerCase().trim()
    
    this.memberItemTargets.forEach(item => {
      const searchText = item.dataset.searchText || ""
      const isMatch = searchText.includes(query)
      
      if (isMatch) {
        item.style.display = ""
        item.classList.remove("hidden")
      } else {
        item.style.display = "none"
        item.classList.add("hidden")
      }
    })

    // Show "no results" message if no items are visible
    this.updateNoResultsMessage(query)
  }

  updateNoResultsMessage(query) {
    const existingMessage = this.membersListTarget.querySelector('.no-results-message')
    const visibleItems = this.memberItemTargets.filter(item => 
      !item.classList.contains('hidden') && item.style.display !== 'none'
    )

    if (visibleItems.length === 0 && query.length > 0) {
      if (!existingMessage) {
        const noResultsElement = document.createElement('div')
        noResultsElement.className = 'no-results-message text-center py-8 text-base-content/60'
        noResultsElement.innerHTML = `
          <iconify-icon icon="ph:magnifying-glass-minus" class="text-2xl mb-2 block"></iconify-icon>
          <p class="text-sm">No team members found matching "${query}"</p>
        `
        this.membersListTarget.appendChild(noResultsElement)
      }
    } else if (existingMessage) {
      existingMessage.remove()
    }
  }
} 